<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="StatusNav">
          <ul>
            <li v-for="(item,index) in navlist" v-text="item.name+'('+item.count+')'"
              :class="{'StatusNavActive':item.active}" v-on:click="NavSwitch(item.id)"></li>
          </ul>
        </div>

        <div class="xblock-box">
          <div class="xblock layui-form" :class="{'FloatingNav':SelectedNum > 0}">
            <button class="layui-btn xblock-row" v-on:click="AllEdit(1)">批量编辑<i v-if="SelectedNum > 0"
                v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn layui-btn-normal xblock-row" v-on:click="CreateProduct">手动创建</button>
            <button class="layui-btn layui-btn-normal xblock-row" v-on:click="AllEdit(2)" v-if="ix == 2">批量发布<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn layui-btn-danger xblock-row" v-on:click="DeleteItme('all')">批量删除<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <div class="layui-input-inline country_select xblock-row">
              <select name="status" lay-verify="required" lay-filter="shops_selection">
                <option value="0">全部店铺</option>
                <option :value="shop.main_account_id" v-text="shop.merchant_name" v-for="(shop,index) in shops"
                  v-bind:key="index"></option>
              </select>
            </div>
            <div class="layui-input-inline xblock-row">
              <input type="text" name="username" placeholder="请输入商品货号搜索" v-on:keydown.13="ProductList()"
                autocomplete="off" v-model="sku" class="layui-input" />
            </div>
            <div class="layui-input-inline xblock-row">
              <input type="text" name="username" placeholder="请输入商品名称搜索" v-on:keydown.13="ProductList()"
                autocomplete="off" v-model="name" class="layui-input" />
            </div>
            <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="ProductList()"><i
                class="fa fa-search"></i></button>
            <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
            <div class="clear-both"></div>
          </div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-form layui-table-margin">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
                </th>
                <th>图片</th>
                <th>公司</th>
                <th>货号</th>
                <th>采集价格</th>
                <th>标题</th>
                <th style="width: 190px;" v-if="ix == 2">站点发布状态</th>
                <th v-if="ix != 2">状态</th>
                <th v-if="ix == 3">失败原因</th>
                <th>时间</th>
                <th style="width: 220px;">操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr v-for="(item,index) in list">
                <td class="cx-box" :data-ix="index">
                  <div><input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index"
                      :checked="item.active"></div>
                  <div class="list-number" v-text="index+1"></div>
                </td>
                <td>
                  <div class="table_img">
                    <img :src="$picture(item.image)">
                  </div>
                </td>
                <td v-text="item.merchant_name"></td>
                <td v-text="item.sku"></td>
                <td>
                  <i style="font-size: 13px;" v-if="(item.min_price||item.max_price) && item.type !='shopee'">￥</i><i
                    v-if="item.min_price != item.max_price" v-text="item.min_price+'~'+item.max_price"></i><i v-else
                    v-text="item.min_price"></i>
                </td>
                <td><i v-text="item.name"></i></td>
                <td v-if="ix == 2">
                  <ul class="shop-list-status">
                    <li v-for="(data,ix) in item.global_country" class="tipsBox">
                      <i v-if="data.publish_status == 'success'" class="shop-success" :class="'tips'+index+''+ix"
                        :data-pix="index" :data-ix="ix" :data-msg="'已发布'"></i>
                      <i v-else-if="data.publish_status == 'pending'" class="shop-pending" :class="'tips'+index+''+ix"
                        :data-pix="index" :data-ix="ix" :data-msg="'发布中'"></i>
                      <i v-else-if="data.publish_status == 'failed'" class="shop-failed" :class="'tips'+index+''+ix"
                        :data-pix="index" :data-ix="ix" :data-msg="data.failed_reason"></i>
                      <i v-else></i>
                      {{data.country}}
                    </li>
                  </ul>
                </td>
                <td v-if="ix != 2">
                  <div style="width: 80px;">
                    <i v-if="item.type == 1" class="status-box status-box-orange">待上架</i>
                    <i v-else-if="item.type == 2" class="status-box status-box-blue">上架中</i>
                    <i v-else-if="item.type == 3" class="status-box status-box-green">待发布</i>
                    <i v-else-if="item.type == 5" class="status-box status-box-blue">定时发布</i>
                    <i v-else class="status-box status-box-red">上架失败</i>
                  </div>
                </td>
                <td style="min-width: 150px;max-width:400px;" v-if="ix == 3">
                  <i style="word-break:break-all;" v-if="item.error_msg" v-text="item.error_msg"></i>
                  <i v-else>未知</i>
                </td>
                <td v-text="item.created_at"></td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="OpenPage('EditGlobal',item.id)">编辑</button>
                  <button v-if="item.type == 5" class="layui-btn layui-btn-warm"
                    v-on:click="DeleteItme(item.id,'cancel')">取消定时</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="ShowPublish([item])"
                    v-if="item.type == 3">发布</button>
                  <button class="layui-btn layui-btn-warm" v-on:click="OpenPage('origin',item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="DeleteItme(item.id)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
          <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>
      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <div class="loading-mask" :isLoding="isLoding" v-if="isLoding"></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>
  </div>
</template>

<script>
  var self, form, layer, laypage, laydate, isRefresh, TimerFun, PublishBox, xmlModule, dropdown;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Global',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        SelectedNum: 0,
        isLoding: false,
        ix: 0,
        id: null,
        sku: null,
        name: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        auto_translation: false,
        list: [],
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "草稿箱",
        }, {
          id: 4,
          count: 0,
          active: false,
          name: "定时发布",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "上架中",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "待发布",
        }, {
          id: 3,
          count: 0,
          active: false,
          name: "上架失败",
        }],
        shopid: 0,
        CxShop: {
          id: 0,
          pix: 0,
          ix: 0,
          list: []
        },
        shops: [],
        logistics: [],
        merchant_list: [],
        country_list: [{
          failed_reason: null,
          publish_status: false,
          country: "TW"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "ID"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "TH"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "PH"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "SG"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "VN"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "MY"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "BR"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "MX"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "CL"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "CO"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "PL"
        }]
      }
    },
    updated() {
      if (form) {
        form.render();
      }
      self.NumberCheck();
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (nv.query.id) {
            if (self.id != nv.query.id) {
              self.id = nv.query.id;
              self.list = [];
              self.NavSwitch(0, nv.query.id);
            }
          } else {
            if (self.list.length > 0) {
              $('.pagebox').show();
            }
          }
        }
      },
      deep: true
    },
    beforeDestroy() {
      clearTimeout(TimerFun);
    },
    mounted() {
      self = this;
      self.SetNavActive("上架", self.$route.name);
      let ix = self.$route.query.ix; //导航ID
      scrollTop(); //监听滚动置顶

      //监听浏览器返回
      window.addEventListener("popstate", function(e) {
        if (self.$route.name == "Global") {
          let ix = self.$route.query.ix; //导航ID
          if (ix) {
            self.ix = ix;
            self.NavSwitch(ix);
          }
        }
        event.preventDefault();
      }, false);

      layui.use(['form', 'layer', 'laydate', 'laypage', 'dropdown'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;
        dropdown = layui.dropdown;

        if (ix) {
          self.ix = ix;
          self.NavSwitch(ix);
        } else {
          self.NavSwitch(0);
        }

        self.get_count();
        self.get_shop_list();
        self.get_logistics_list();
        self.VersionCheck(); //版本检测

        //全选店铺
        form.on('switch(shop_switch)', function(data) {
          var child = $(".product-html input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = status;
            for (let i in self.merchant_list) {
              for (let x in self.merchant_list[i].shop_list) {
                self.merchant_list[i].shop_list[x].active = status;
              }
            }
          });
          form.render('checkbox');
        });

        //店铺选择
        form.on('checkbox(shop_select)', function(data) {
          let pix = data.elem.dataset.pix;
          let ix = data.elem.dataset.ix;

          if (self.merchant_list[pix].shop_list[ix].active) {
            self.merchant_list[pix].shop_list[ix].active = false;
          } else {
            self.merchant_list[pix].shop_list[ix].active = true;
          }
        });

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
            if (status) {
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

        //店铺选择
        form.on('select(shops_selection)', function(data) {
          self.shopid = data.value;
          self.ProductList();
        });

        //自动翻译
        form.on('checkbox(auto_translation)', function(data) {
          self.auto_translation = data.elem.checked;
        });

        //促销点击选择
        form.on('submit(cx-select)', function(data) {
          self.CxShop.id = data.elem.dataset.sid;
          self.CxShop.pix = data.elem.dataset.pix;
          self.CxShop.ix = data.elem.dataset.ix;
          self.RefreshDiscounts();
        });

        //促销选中
        form.on('submit(PromotionSubmit)', function(data) {
          let discount_info = {
            id: data.elem.dataset.id,
            name: data.elem.dataset.name
          };

          for (let i in self.merchant_list) {
            for (let x in self.merchant_list[i].shop_list) {
              if (self.merchant_list[i].shop_list[x].shop_id == self.CxShop.id) {
                self.merchant_list[i].shop_list[x].discount_info = discount_info;
              }
            }
          }

          $('.cx-name' + self.CxShop.pix + self.CxShop.ix).text("（" + data.elem.dataset.name + "）").removeClass(
            "redColor");
          self.modal_box_close();
        });

        //文字提示
        var tips;
        $("#main-box").on('mouseenter', '.tipsBox', function(event) {
          let pix = $(this).find('i').attr("data-pix");
          let ix = $(this).find('i').attr("data-ix");
          let msg = $(this).find('i').attr("data-msg");
          if (msg) {
            tips = layer.tips(msg, '.tips' + pix + ix, {
              tips: 1,
              time: 999999
            });
          }
        });
        $("#main-box").on('mouseleave', '.tipsBox', function(event) {
          layer.close(tips);
        });

      });

      $(".layui-body").scroll(function() {
        let scrollTop = $(this).scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      })

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      DeleteItme(id, etype) {
        if (id == "all") {
          self.Confirm.txt = "是否确认批量删除？";
          self.Confirm.te = 'all';
        } else {
          self.Confirm.txt = "是否确认删除？"
          self.Confirm.te = 'one';
        }
        if (etype == "cancel") {
          self.Confirm.txt = "是否确定取消定时？"
          self.Confirm.te = 'cancel';
        }
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.itemid = id;
      },
      VersionCheck() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if (json.code == 200) {
            if (json.datas.version != localStorage.getItem("ExShopee_Version")) {
              localStorage.setItem("ExShopee_Version", json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      ProductList(id) {
        self.list = [];
        let param = new URLSearchParams()
        if (id) {
          param.append('id', id)
        }
        if (self.sku) {
          param.append('sku', self.sku)
        }
        if (self.name) {
          param.append('name', self.name)
        }
        param.append('shop_id', self.shopid)
        param.append('type', self.ix)
        param.append('num', self.page_num)
        var _url = "/get_production_merchant_list/"
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url + '?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              self.total = datas.total;
              for (let i in list) {
                list[i].active = false;
                var country_list = JSON.parse(JSON.stringify(self.country_list));

                if (list[i].categories && list[i].categories.length > 0) {
                  list[i].isSpecial = list[i].categories[list[i].categories.length - 1].category_type; //货物类型
                } else {
                  list[i].isSpecial = 0;
                }

                if (list[i].global_country) {
                  var countrys = JSON.parse(list[i].global_country);
                  for (let x in country_list) {
                    for (let y in countrys) {
                      if (country_list[x].country == countrys[y].country) {
                        country_list[x] = countrys[y]
                      }
                    }
                  }
                }
                list[i].global_country = country_list;

                let max_price = list[i].price[0];
                let min_price = list[i].price[0];
                for (let y in list[i].models) {
                  if (list[i].models[y].price && list[i].models[y].price > max_price) {
                    max_price = list[i].models[y].price;
                  }
                  if (list[i].models[y].price && list[i].models[y].price < min_price) {
                    min_price = list[i].models[y].price;
                  }
                }
                list[i].min_price = min_price;
                list[i].max_price = max_price;
              }

              // console.log(list)
              self.list = list;
              self.$forceUpdate();
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();

            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      OpenPage(url, data) {
        if (url == "origin") {
          window.open(data);
        } else {
          localStorage.setItem("ExShopee_EditType", 1);
          self.$router.push({
            path: url + '?id=' + data
          }) // 路由跳转
        }
      },
      ConfirmBackFun(data) {

        self.Confirm.state = data.state;
        if (data.state) {
          var ids = [],
            _url = "/product_merchant_del/";
          if (self.Confirm.te == "all") {
            for (let i in self.list) {
              if (self.list[i].active) {
                ids.push(self.list[i].id);
              }
            }
          } else {
            ids.push(self.itemid);
          }
          if (self.Confirm.te == "cancel") {
            _url = "/task_cancel/";
          }
          self.loading = true;
          self.Confirm.state = false;
          $.ajax({
            url: self.GetServerUrl() + _url,
            type: 'post',
            data: {
              id: JSON.stringify(ids),
              p_type: 1,
            },
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              layer.close(layer.index);
              var json = JSON.parse(res);
              if (json.code == 200) {
                self.ToastFun(0, json.msg); //弹窗提醒
                $('.cxall').prop('checked', false);
                self.ProductList();
                self.get_count();
              } else {
                self.ToastFun(1, json.msg); //弹窗提醒
              }
            },
            error: function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            }
          })
        }
      },
      get_count() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/p_get_status_number_merchant/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          var json = response.data;
          if (json.code == 200) {
            for (let i in self.navlist) {
              self.navlist[i].count = json.datas.count_arr[i]
            }
            if (json.datas.count_arr[2] > 0) {
              TimerFun = setTimeout(function() {
                isRefresh = true;
                self.get_count();
              }, 2000)
            } else {
              if (isRefresh) {
                self.ProductList();
                isRefresh = false;
              }
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      AllEdit(te) {
        var ids = [],
          list = [];
        for (let i in self.list) {
          if (self.list[i].active) {
            list.push(self.list[i]);
            ids.push(self.list[i].id);
          }
        }
        localStorage.setItem("ExShopee_EditIds", JSON.stringify(ids));
        if (ids.length > 0) {
          if (te == 1) {
            localStorage.setItem("ExShopee_EditType", 1);
            self.$router.push({
              path: 'BulkGlobal'
            }) // 路由跳转
          } else if (te == 2) {
            self.ShowPublish(list);
          }
        } else {
          self.ToastFun(1, "请选择产品！"); //弹窗提醒
        }
      },
      NavSwitch(ix, id) {
        let nix;
        $('.cxall').prop('checked', false);
        self.GoToPage('/Global?ix=' + ix); // 路由跳转
        for (let i in self.navlist) {
          self.navlist[i].active = false;
          if (self.navlist[i].id == ix) {
            nix = i;
          }
        }
        self.navlist[nix].active = true;
        self.ix = ix;
        self.list = [];
        if (id) {
          self.ProductList(id);
        } else {
          self.ProductList();
        }
      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_merchant/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              self.shops = datalist;
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      ShowPublish(data) {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        PublishBox = layer.open({
          type: 1,
          offset: '100px',
          title: "选择发布站点",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定发布', '刷新列表'],
          skin: 'package-box',
          content: PublishHtml,
          success: function() {
            self.auto_translation = false;
            self.LoadShopList(data);
          },
          yes: function(index, layero) {
            // layer.msg("shopee已修改上架规则，请等待系统更新！");
            self.Publish();
          },
          btn2: function(index, layero) {
            $('.shop_switch').prop('checked', false);
            self.LoadShopList(data);
            return false;
          },
          end: function() {
            self.CxShop.list = [];
          }
        });
      },
      LoadShopList(data) {
        self.loading = true;
        let param = new URLSearchParams()
        var ids = [];
        for (let i in data) {
          if (ids.indexOf(data[i].id) < 0) {
            ids.push(data[i].id);
          }
        }
        param.append('id', JSON.stringify(ids));

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_merchant_by_id/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            // console.log(datas)

            //发布的站点
            var xhtml = '',
              chtml = '',
              shops = [{
                id: 'all',
                title: "全部选中"
              }]
            for (let i in data) {
              xhtml += '<tr>'
              xhtml += '<td><img src="' + data[i].image + '"></td>'
              xhtml += '<td>' + data[i].merchant_name + '</td>'
              xhtml += '<td>' + data[i].name + '</td>'
              xhtml += '<td>'
              for (let x in datas) {
                if (data[i].main_account_id == datas[x].main_account_id) {
                  xhtml += '<div style="margin-bottom:20px;">';
                  for (let y in datas[x].shop_list) {
                    xhtml += '<input type="checkbox" class="shop_select shop-btn-' + i + y +
                      '" lay-filter="shop_select" data-pix="' +
                      i +
                      '" data-ix="' + y + '" title="' + datas[x].shop_list[y].shop_name + '-' + datas[x]
                      .shop_list[y].country + '">'
                    datas[x].shop_list[y].active = false;

                    //促销店铺
                    if ($.inArray(datas[x].shop_list[y].shop_id, self.CxShop.list) == -1) {
                      self.CxShop.list.push(datas[x].shop_list[y].shop_id);
                      chtml +=
                        '<button class="all-img" type="button" lay-filter="cx-select" lay-submit data-sid="' +
                        datas[x].shop_list[y].shop_id + '" data-pix="' + i + '" data-ix="' + y + '">' + datas[x]
                        .shop_list[y].shop_name + '-' + datas[x].shop_list[y].country + '<i class="cx-name' +
                        i + y + ' NoSelect redColor">（点击选择）</i></button>'
                      shops.push({
                        id: datas[x].shop_list[y].shop_id,
                        title: datas[x].shop_list[y].shop_name + '-' + datas[x].shop_list[y].country
                      });
                    }

                  }
                  xhtml += '</div>';
                  data[i].shop_list = JSON.parse(JSON.stringify(datas[x].shop_list));
                }

              }
              xhtml += '</td>'
              xhtml += '</tr>'
            }
            $(".product-html").html(xhtml);
            $(".cx-btn-arr").html(chtml);
            self.merchant_list = data;

            //下拉选择店铺
            dropdown.render({
              elem: '.shop-select',
              data: shops,
              click: function(obj) {
                var status = true;
                for (let i in self.merchant_list) {
                  for (let x in self.merchant_list[i].shop_list) {
                    if (obj.id == "all") {
                      if (obj.title == "全部取消") {
                        status = false;
                      }
                      $(".shop-btn-" + i + x + "").prop("checked", status);
                      self.merchant_list[i].shop_list[x].active = status;
                    } else {
                      if (self.merchant_list[i].shop_list[x].shop_id == obj.id) {
                        if ($(".shop-btn-" + i + x + "").is(':checked')) {
                          $(".shop-btn-" + i + x + "").prop("checked", false);
                          self.merchant_list[i].shop_list[x].active = false;
                        } else {
                          $(".shop-btn-" + i + x + "").prop("checked", true);
                          self.merchant_list[i].shop_list[x].active = true;
                        }
                      }
                    }
                  }
                }
                if (obj.id == "all" && shops.length > 0) {
                  if (status) {
                    shops[0].title = "全部取消";
                  } else {
                    shops[0].title = "全部选中";
                  }
                }
                form.render('checkbox');
              }
            });

          }, function() {
            var xhtml = '<div class="transition">'
            xhtml += '<div class="transitionImg"><img src="../../../static/images/error.png"></div>'
            xhtml += '<div class="transitionHint">加载失败</div>'
            xhtml += '</div>'
            $('.transition-html').html(xhtml);
            form.render();
          });

        }).catch(function(error) {
          self.loading = false;

          var xhtml = '<div class="transition">'
          xhtml += '<div class="transitionImg"><img src="../../../static/images/error.png"></div>'
          xhtml += '<div class="transitionHint">加载失败</div>'
          xhtml += '</div>'
          $('.transition-html').html(xhtml);
          form.render();
        })
      },
      Publish() {
        var shops = [];
        for (let i in self.merchant_list) {
          var global_tier_variations, customize_models;
          if (self.merchant_list[i].global_tier_variations && self.merchant_list[i].global_tier_variations.length > 2) {
            global_tier_variations = JSON.parse(self.merchant_list[i].global_tier_variations)
          }
          if (self.merchant_list[i].customize_tier_variations && self.merchant_list[i].customize_tier_variations
            .length > 0) {
            customize_models = JSON.parse(JSON.stringify(self.merchant_list[i].customize_tier_variations)); //自定义SKU
          }
          var pricing = self.merchant_list[i].pricing; //定价模板
          var weight = self.merchant_list[i].weight; //重量
          var current_county; //重量

          for (let x in self.merchant_list[i].shop_list) {
            if (global_tier_variations) {
              var models = JSON.parse(JSON.stringify(global_tier_variations.global_model)); //SKU
            } else {
              var models = [];
            }

            if (self.merchant_list[i].shop_list[x].active) {
              shops.push(self.merchant_list[i].shop_list[x]); //判断是否选中店铺

              //添加物流方式
              for (let l in self.logistics) {
                if (self.logistics[l].country == self.merchant_list[i].shop_list[x].country) {
                  var logistics = JSON.parse(self.logistics[l].data);
                  var log = [];
                  for (let k in logistics) {
                    log.push({
                      enabled: true,
                      logistic_id: logistics[k].logistics_channel_id
                    })
                  }
                  self.merchant_list[i].shop_list[x].logistic = log;
                }
              }

              //判断是否是新版，是否有定价模板
              if (pricing && pricing.name) {
                var cy = self.merchant_list[i].shop_list[x].country;
                for (let e in country) {
                  if (cy == country[e].en_name) {
                    current_county = country[e];
                  }
                }

                if (models && models.length > 0) {
                  for (let z in models) {
                    //以SKU重量为准
                    if (customize_models[z] && customize_models[z].weight) {
                      weight = customize_models[z].weight;
                    } else {
                      weight = self.merchant_list[i].weight;
                    }
                    var freight = parseFloat(self.FreightCount(self.merchant_list[i].isSpecial, cy, weight)); //运费
                    var price = models[z].original_price;
                    var prices = self.PricingToolGlobalRelease(price, freight, current_county, pricing); //自动定价返回
                    models[z].original_price = prices[1]; //藏价公式
                    models[z].price = prices[0]; //藏价公式
                  }
                } else {
                  var freight = parseFloat(self.FreightCount(self.merchant_list[i].isSpecial, cy, weight)); //运费
                  let price = parseFloat(self.merchant_list[i].min_price);
                  var prices = self.PricingToolGlobalRelease(price, freight, current_county, pricing); //自动定价返回
                  self.merchant_list[i].shop_list[x].original_price = prices[1]; //藏价公式
                  self.merchant_list[i].shop_list[x].price = prices[0]; //藏价公式
                }
                self.merchant_list[i].shop_list[x].models = models; //重写价格
              }

            }
          }
        }

        if (shops.length <= 0) {
          layer.msg("店铺不能为空！");
          return;
        }

        var is_auto = 0;
        if (self.auto_translation) {
          is_auto = 1;
        }

        //测试
        // console.log(self.merchant_list);
        // return;

        let param = new URLSearchParams()
        param.append('is_auto', is_auto);
        param.append('datas', JSON.stringify(self.merchant_list));
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/publish_batch/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            layer.msg("已发布，请在列表查看站点发布状态！");
            $('.cxall').prop('checked', false);
            layer.close(PublishBox);
            self.ProductList();
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_discounts_list(etype) {
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + '/get_discounts_list/',
          type: 'post',
          data: {
            shop_id: self.CxShop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.loading = false;
            var json = JSON.parse(res);
            self.loading = false;
            if (json.code == 200) {
              var discounts = json.datas.discount;

              if (etype) {
                var chtml = ""
                for (var i in discounts) {
                  chtml += '<tr>'
                  chtml += '<td>' + discounts[i].discount_id + '</td>'
                  chtml += '<td>' + discounts[i].discount_name + '</td>'
                  chtml += '<td>'
                  if (discounts[i].status == "upcoming") {
                    chtml += '<i class="status-box status-box-red">即将开始的活动</i>'
                  } else {
                    chtml += '<i class="status-box status-box-red">进行中</i>'
                  }
                  chtml += '</td>'
                  chtml += '<td>'
                  chtml += '<div>开始：' + self.timestampToTime(discounts[i].start_time) + '</div>'
                  chtml += '<div>结束：' + self.timestampToTime(discounts[i].end_time) + '</div>'
                  chtml += '</td>'
                  chtml +=
                    '<td><button class="layui-btn layui-btn-normal" lay-filter="PromotionSubmit" data-id="' +
                    discounts[i].discount_id + '" data-name="' + discounts[i].discount_name +
                    '" type="button" lay-submit>选择</button></td>'
                  chtml += '</tr>'
                }
                $("#table-html").html(chtml);
              } else {
                self.modal_box_show(self, 'PromotionList', '促销活动', discounts);
              }
            } else if (json.code == 401) {

            } else {
              self.modal_box_show(self, 'PromotionList', '促销活动', discounts);
            }
          },
          error: function() {
            self.loading = false;
          }
        })
      },
      RefreshDiscounts() {
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + '/refresh_discount_list/',
          type: 'post',
          data: {
            shop_id: self.CxShop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.loading = false;
            var json = JSON.parse(res);
            self.get_discounts_list();
          },
          error: function() {
            self.loading = false;
          }
        })
      },
      AddPromotion() {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
          if (w > 500) {
            w = 500;
          }
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
          if (h > 410) {
            h = 410;
          }
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "添加活动",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: PromotionAdd,
          success: function() {
            laydate.render({
              elem: '#start_date',
              type: 'datetime',
              min: 0,
              max: 180,
            });
            laydate.render({
              elem: '#end_date',
              type: 'datetime',
              min: 0,
              max: 180,
            });
            form.render();
          },
          yes: function(index, layero) {
            let name = $("#promotion_name").val();
            let start_date = $("#start_date").val();
            let end_date = $("#end_date").val();
            if (self.empty(name)) {
              layer.msg("促销名称不能为空！");
              return;
            }
            if (self.empty(start_date) && self.empty(end_date)) {
              layer.msg("促销时间不能为空！");
              return;
            }

            let param = new URLSearchParams()
            param.append('shop_id', self.CxShop.id);
            param.append('discount_name', name);
            param.append('start_time', start_date);
            param.append('end_time', end_date);
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + '/add_discounts/',
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(res) {
              var json = res.data;
              layer.msg(json.msg);
              if (json.code == 200) {
                self.get_discounts_list(true); //促销活动
                layer.close(xmlModule);
              } else {
                self.loading = false;
              }
            }).catch(function(error) {
              self.loading = false;
              layer.msg(error);
            })

          }
        });
      },
      CreateProduct() {
        self.$router.push({
          path: "EditGlobal"
        })
      },
      NumberCheck() {
        let num = 0;
        for (let i in self.list) {
          if (self.list[i].active) {
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      },
      get_logistics_list(shops) {
        $.ajax({
          url: self.GetServerUrl() + '/get_logistics_list/',
          type: 'get',
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            var json = JSON.parse(res);
            if (json.code == 200) {
              self.logistics = json.datas.data;
              // console.log(self.logistics)
            } else {
              console.log(json.msg);
            }
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .shop-list-status {
    width: 190px;
    overflow: hidden;
  }

  .shop-list-status li {
    cursor: pointer;
  }

  .shop-list-status li:hover {
    opacity: 0.8;
  }

  .shop-list-status i {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 8px;
    background-color: #C3C3C3;
  }

  .shop-list-status li {
    float: left;
    line-height: 25px;
    padding-left: 15px;
    position: relative;
    width: 22px;
    margin-left: 20px;
  }

  .shop-success {
    background-color: #5c7 !important;
  }

  .shop-pending {
    background-color: #f90 !important;
  }

  .shop-failed {
    background-color: #f00 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Global.vue